import { Button } from '@mui/material';
import { netsuiteIntegrationSelectors } from '@vy/app-selectors';
import { useFormContext } from 'react-hook-form';
import { isEmptyObject, awaitAllSafely } from '@vy/utils';
import type { FC } from 'react';
import type { NetSuiteConfigurationControl, NetSuiteConfigurationFormValues } from '../NetSuiteConfigurationFormSchema';
import { useFetchNetSuiteSettings } from '../hooks/useFetchNetSuiteSettings';
import { useModifyNetSuiteConfiguration } from '../hooks/useModifyNetSuiteConfiguration';
import { useIntegrationContextProvider } from '../../../../hooks/use-integration-context-provider';
import { getNetSuiteIntegrationSettings } from './utils';

type NetSuiteConfigurationFooterProps = {
  control: NetSuiteConfigurationControl;
};

export const NetSuiteConfigurationFooter: FC<NetSuiteConfigurationFooterProps> = () => {
  const { integrationId, configuration: existingConfiguration } = useFetchNetSuiteSettings();
  const updateNetSuiteConfiguration = useModifyNetSuiteConfiguration();
  const { clearSelectedIntegration } = useIntegrationContextProvider();

  const {
    handleSubmit,
    formState: { dirtyFields },
    reset,
  } = useFormContext<NetSuiteConfigurationFormValues>();

  const getUpdateNetSuiteConfigurationPromise = async (formValues: NetSuiteConfigurationFormValues) => {
    if (isEmptyObject(dirtyFields)) {
      return undefined;
    }

    const existingIntegrationSettings = getNetSuiteIntegrationSettings(existingConfiguration);
    const updatedIntegrationSettings = getNetSuiteIntegrationSettings(formValues);

    return updateNetSuiteConfiguration(integrationId, updatedIntegrationSettings, existingIntegrationSettings);
  };

  const submitHandler = handleSubmit(async (formValues) => {
    const updateNetSuiteConfigurationPromise = getUpdateNetSuiteConfigurationPromise(formValues);

    await awaitAllSafely(updateNetSuiteConfigurationPromise);

    reset(formValues);
    clearSelectedIntegration();
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button
        variant="contained"
        onClick={submitHandler}
        data-vy={netsuiteIntegrationSelectors.configuration.saveButton}
      >
        Save Configuration
      </Button>
    </div>
  );
}; 